import ApiService from "../api";

export default class JornadaTrabalhadaService extends ApiService {

    constructor() {
        super('/api/jornadas-trabalhadas')
    }

    relatorioConsolidado(values) {
        const {
            funcionario = [],
            cargo = [],
            filial = [],
            dataInicial = null,
            dataFinal = null,
        } = values;

        const params = new URLSearchParams();
        params.append("dataInicial", dataInicial);
        params.append("dataFinal", dataFinal);
        if (funcionario.length) params.append("funcionario", funcionario.join(","));
        if (cargo.length) params.append("cargo", cargo.join(","));
        if (filial.length) params.append("filial", filial.join(","));

        return this.get(`/relatorio-consolidado?${params}`);
    }

    listarFaltas(values) {
        const {
            funcionario = [],
            cargo = [],
            filial = [],
            dataInicial = null,
            dataFinal = null,
        } = values;

        const params = new URLSearchParams();
        params.append("dataInicial", dataInicial);
        params.append("dataFinal", dataFinal);
        if (funcionario.length) params.append("funcionario", funcionario.join(","));
        if (cargo.length) params.append("cargo", cargo.join(","));
        if (filial.length) params.append("filial", filial.join(","));

        return this.get(`/faltas?${params}`);
    }

    listarHorasExtras(values) {
        const {
            funcionario = [],
            cargo = [],
            filial = [],
            dataInicial = null,
            dataFinal = null,
        } = values;

        const params = new URLSearchParams();
        params.append("dataInicial", dataInicial);
        params.append("dataFinal", dataFinal);
        if (funcionario.length) params.append("funcionario", funcionario.join(","));
        if (cargo.length) params.append("cargo", cargo.join(","));
        if (filial.length) params.append("filial", filial.join(","));

        return this.get(`/horas-extras?${params}`);
    }

    exportarExcel(values) {
        const {
            funcionario = [],
            cargo = [],
            filial = [],
            dataInicial = null,
            dataFinal = null,
        } = values;

        const params = new URLSearchParams();

        if (dataInicial) params.append("dataInicial", dataInicial);
        if (dataFinal) params.append("dataFinal", dataFinal);

        if (funcionario?.length) { params.append("funcionario", funcionario.join(",")); }
        if (cargo?.length) { params.append("cargo", cargo.join(",")); }
        if (filial?.length) { params.append("filial", filial.join(",")); }

        return this.getFile(`/exportar?${params.toString()}`);
    }

    listaJornadaPorFuncionario(values) {
        const {
            funcionario = null,
            dataInicial = null,
            dataFinal = null,
        } = values;

        const params = new URLSearchParams();
        params.append("dataInicial", dataInicial);
        params.append("dataFinal", dataFinal);
        params.append("funcionario", funcionario);

        return this.get(`/funcionario?${params}`);
    }

    dashboardHorasExtras(values) {
        const {
            ano = null,
            mes = null,
            filialId = null,
        } = values;

        const params = new URLSearchParams();
        params.append("ano", ano);
        params.append("mes", mes);
        params.append("filialId", filialId);

        return this.get(`/dashboard?${params}`);
    }

    filtros(values) {
        const {
            funcionario = [],
            cargo = [],
            filial = [],
        } = values;

        const params = new URLSearchParams();
        if (funcionario.length) params.append("funcionario", funcionario.join(","));
        if (cargo.length) params.append("cargo", cargo.join(","));
        if (filial.length) params.append("filial", filial.join(","));

        return this.get(`/filtros?${params}`);
    }


}